import { useLocation, useSearchParams } from 'react-router-dom';

const ListFilters = ({ filters, onChangeFilter }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <div className='ms:container ms:mx-auto px-4 ms:px-2 font-museo  flex gap-x-5 my-5   '>
      <div className="flex">

        {(location.search !=="?serach=fav") && filters?.map(filter => (
          <div key={`filter-${filter?.value}`}  className="sm:mr-5 ms:mr-3 mr-2 flex">
            <span onClick={() => onChangeFilter(filter?.value)} className={`${filter?.is_active ? ' active:text-slate-700 border-slate-700' : 'text-slate-400 border-slate-400'} cursor-pointer text-[8px] ssm:text-[10px] ms:text-[11px] sm:text-lg border-b-2  font-museobb `}>{filter?.name}</span>
            {!filter?.is_active && (<span className=" relative bottom-2 inline-flex justify-center items-center w-3 h-3 sm:w-4 sm:h-4  font-museob sm:text-xs text-[7px] ssm:text-[8px] ms:text-[11px]  text-white bg-red-700 rounded-full">{filter?.count}</span>)}
          </div>
        ))}
        {(location.search==="?serach=fav")&&
          <div className="sm:mr-5 ms:mr-3 mr-2 flex">
            <span onClick={() => setSearchParams("")} className=" active:text-slate-700 border-slate-700' : 'text-slate-400 border-slate-400 cursor-pointer text-[8px] ssm:text-[10px] ms:text-[11px] sm:text-lg border-b-2  font-museobb">All Campaigns</span>
          </div>
        }
      </div>
    </div>
  );
}

export default ListFilters